export default __webpack_public_path__ + "1fd40546b68766b7b0bf18cf1daf2e48.png";